const getQueryString = (params) => {
    let additionalUrl = ''

    for (const [key, value] of Object.entries(params)) {
        if (value)
            additionalUrl += `&${key}=${value}`
    }

    return additionalUrl
}

export default function apiLink(url, params) {

    let additionalUrl = getQueryString(params)

    if (url.indexOf('?') !== -1)
        return url + additionalUrl

    return url + '?' + additionalUrl.substring(1)
}